import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {
  removeFilteredCategory,
  setFilterCount,
  changeActiveFilters,
  clearAllFilterCounts,
} from '../../redux/Filters';
import TranslationLabel from '../TranslationLabel';

function ActiveFiltersBanner() {
  const filterCount = useSelector(state => state.showFilters.filterCount);
  const activeFilters = useSelector(state => state.showFilters.activeFilters);
  const dispatch = useDispatch();

  const removeFilter = e => {
    dispatch(
      removeFilteredCategory({
        id: e.target.id,
        filteredCategory: e.target.previousSibling.innerText,
      })
    );

    if (filterCount > 0) {
      dispatch(setFilterCount(e.target.id));
    } else {
      dispatch(setFilterCount(0));
    }
  };

  const showBanner = () => {
    return filterCount.count > 0;
  };

  const clearAllFilters = () => {
    dispatch(changeActiveFilters([]));
    dispatch(clearAllFilterCounts());
    document.querySelectorAll('input').forEach(input => {
      input.checked = false;
    });
  };

  return showBanner() ? (
    <div className="d-flex flex-row flex-wrap filter-banner p-2">
      <div>
        <TranslationLabel id="label_30" defaultValue="Active Filters" />:{' '}
      </div>
      {activeFilters.map((category, index) => (
        <div className="d-flex flex-row" key={index}>
          {category.filteredCategories.length >= 1 && (
            <div className="mx-2 fw-bold">{category.title}:</div>
          )}
          {category.filteredCategories.length > 0 &&
            category.filteredCategories.map((filteredCategory, filtIndex) => (
              <div className="d-flex flex-row" key={filtIndex}>
                <div className="ml-2">{filteredCategory?.text}</div>
                <div
                  id={category.id}
                  className="filter-close"
                  style={{cursor: 'pointer'}}
                  onClick={removeFilter}
                >
                  X
                </div>
                
              </div>
            ))}
        </div>
      ))}
      <div
        className="text-decoration-underline px-3"
        onClick={clearAllFilters}
        style={{cursor: 'pointer'}}
      >
        <TranslationLabel id="label_07" defaultValue="Clear All" />
      </div>
    </div>
  ) : (
    <></>
  );
}

export default ActiveFiltersBanner;
